import _, { get } from 'lodash';
import { withTZ } from '../../../helpers/dateTime';
import actions from './actions';
import { createReducer } from '../../../helpers/reducer';
import { t } from '../../../i18n';

const initState = {
  events: [],
  eventsFiltered: [],
  loading: false,
  jobs: null,
  total: 0,
  filteredTotal: 0,
  timeZone: null,
  viewFilters: ['calendarUnfilled', 'calendarFulfilled', 'calendarPartFilled'],
};

function filterEvents(events, filterProps) {
  const [type1, type2, type3] = filterProps;

  return events.filter(event => {
    return event.type === type1 || event.type === type2 || event.type === type3;
  });
}

const transformEventsObjectToArray = events => {
  const arrayOfEvents = [];
  _.keys(events).forEach(key => {
    if (events[key].unfulfilled) {
      const assignedTotal = get(events[key], 'unfulfilled.workers_assigned_total', 0);
      const requiredTotal = get(events[key], 'unfulfilled.workers_required_total', 0);
      arrayOfEvents.push({
        id: key,
        date: key,
        title: t('dash.jobs.calendarView.unfulfilled_title'),
        assignedTotal,
        requiredTotal,
        type: 'calendarUnfilled',
        start: withTZ(key),
        end: withTZ(key),
      });
    }

    if (events[key].part_filled) {
      const assignedTotal = get(events[key], 'part_filled.workers_assigned_total', 0);
      const requiredTotal = get(events[key], 'part_filled.workers_required_total', 0);
      arrayOfEvents.push({
        id: key,
        date: key,
        title: t('dash.jobs.calendarView.part_filled_title'),
        assignedTotal,
        requiredTotal,
        type: 'calendarPartFilled',
        start: withTZ(key),
        end: withTZ(key),
      });
    }

    if (events[key].fulfilled) {
      const assignedTotal = get(events[key], 'fulfilled.workers_assigned_total', 0);
      const requiredTotal = get(events[key], 'fulfilled.workers_required_total', 0);
      arrayOfEvents.push({
        id: key,
        date: key,
        title: t('dash.jobs.calendarView.filled_title'),
        assignedTotal,
        requiredTotal,
        type: 'calendarFulfilled',
        start: withTZ(key),
        end: withTZ(key),
      });
    }
  });

  return arrayOfEvents;
};

const onLoad = state => {
  return {
    ...state,
    loading: true,
  };
};

const onLoadSuccess = (state, { payload }) => {
  const { events } = payload;
  const { viewFilters } = state;
  const arrayOfEvents = transformEventsObjectToArray(events);

  return {
    ...state,
    loading: false,
    events: arrayOfEvents,
    eventsFiltered: viewFilters.length !== 3 ? filterEvents(arrayOfEvents, viewFilters) : arrayOfEvents,
  };
};

const onLoadJobsSuccess = (state, { payload }) => {
  const { data, total, filteredTotal, filters, savedSearches } = payload;

  return {
    ...state,
    jobs: data,
    total,
    filteredTotal,
    filters,
    loading: false,
    savedSearches,
    timeZone: data?.[0]?.time_zone || state.timeZone,
  };
};

const onEventsFiltering = (state, { filterProperties }) => {
  const filteredEvents = filterEvents(state.events, filterProperties);

  return {
    ...state,
    viewFilters: filterProperties,
    eventsFiltered: filteredEvents,
  };
};

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_JOBS]: onLoad,
  [actions.LOAD_JOBS_SUCCESS]: onLoadJobsSuccess,
  [actions.EVENTS_FILTERING]: onEventsFiltering,
  [actions.CLEAR_STORE]: onClearStore,
});
